// Utility functions for consistent date/time formatting in CET (Europe/Paris)

export const CET_TIMEZONE = 'Europe/Paris';

export function formatDate(dateInput, options = {}) {
  const date = new Date(dateInput);
  return date.toLocaleDateString('en-GB', { timeZone: CET_TIMEZONE, ...options });
}

export function formatDateTime(dateInput, options = {}) {
  const date = new Date(dateInput);
  return date.toLocaleString('en-GB', { timeZone: CET_TIMEZONE, ...options });
}
